import * as React from "react"
import DeleteConfirmationModalComponent from "./DeleteConfirmationModalComponent"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus"
import { faMinus } from "@fortawesome/free-solid-svg-icons/faMinus"
import { faAngleUp } from "@fortawesome/free-solid-svg-icons/faAngleUp"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown"
import { CPHyperLink } from "../models/CPHyperLink"
import { CPLinkType } from "../enums/CPLinkType"
const cloneDeep = require('lodash.clonedeep')

export interface LinksListProps {
    links: Array<CPHyperLink>,
    setLinks: Function,
    disabled: boolean,
}

const LinksList = (props: LinksListProps) => {

    const moveLinkUp = linkIndex => {
        if (linkIndex > 0) {
            var updatedLinks = cloneDeep(props.links)
            var linkMovingUp = cloneDeep(updatedLinks[linkIndex])
            var linkMovingDown = cloneDeep(updatedLinks[linkIndex - 1])
            updatedLinks[linkIndex] = linkMovingDown
            updatedLinks[linkIndex - 1] = linkMovingUp
            props.setLinks(updatedLinks)
        }
    }

    const moveLinkDown = linkIndex => {
        if (linkIndex < props.links.length - 1) {
            var updatedLinks = cloneDeep(props.links)
            var linkMovingUp = cloneDeep(updatedLinks[linkIndex + 1])
            var linkMovingDown = cloneDeep(updatedLinks[linkIndex])
            updatedLinks[linkIndex + 1] = linkMovingDown
            updatedLinks[linkIndex] = linkMovingUp
            props.setLinks(updatedLinks)
        }
    }

    const addLink = linkIndex => {

        var updatedLinks = cloneDeep(props.links)
        var newLink = { url: "", type: CPLinkType.Web }
        updatedLinks.splice(linkIndex + 1, 0, newLink)
        props.setLinks(updatedLinks)
    }

    const removeLink = linkIndex => {
        var updatedLinks = cloneDeep(props.links)
        updatedLinks.splice(linkIndex, 1)
        props.setLinks(updatedLinks)
    }

    const changeLinkType = (linkIndex, input) => {
        var updatedLinks = cloneDeep(props.links)
        updatedLinks[linkIndex].type = input.value
        props.setLinks(updatedLinks)
    }

    const changeLinkUrl = (linkIndex, input) => {
        var updatedLinks = cloneDeep(props.links)
        updatedLinks[linkIndex].url = input
        props.setLinks(updatedLinks)
    }

    return (
        <div className="row">
            <div className="col">
                <b>Links:</b>
                <ol className="border rounded">
                    {props.links.length == 0 && !props.disabled ?
                        <b><a onClick={() => addLink(-1)}>Add Help Link</a></b> : ""
                    }

                    {props.links.map((link, linkIndex) => {
                        return (
                            <li className="linkList" key={linkIndex}>
                                <div className="row my-2">
                                    <div className="col">
                                        <input type="text" disabled={props.disabled} className="form-control" placeholder="Enter Link..." onChange={e => changeLinkUrl(linkIndex, e.currentTarget.value)} value={link.url}></input>
                                    </div>
                                    {!props.disabled ?
                                        <div className="col-auto">
                                            <div className="row align-items-center">
                                                <div className="col-auto px-1">
                                                    {linkIndex != 0 ? <><FontAwesomeIcon icon={faAngleUp} role="button" onClick={() => moveLinkUp(linkIndex)} /><br /></> : ""}
                                                    {linkIndex != props.links.length - 1 ? <FontAwesomeIcon icon={faAngleDown} role="button" onClick={() => moveLinkDown(linkIndex)} /> : ""}
                                                </div>
                                                <div className="col-auto">
                                                    <a role="button" onClick={() => addLink(linkIndex)}><FontAwesomeIcon icon={faPlus} /><b>&nbsp;Add</b></a>
                                                    &emsp;
                                                    <a role="button" data-bs-toggle="modal" data-bs-target={"#removeLinkModal" + (linkIndex)}><FontAwesomeIcon icon={faMinus} /><b>&nbsp;Remove</b></a>
                                                </div>
                                                &emsp;
                                            </div>
                                        </div> : ""}
                                </div>
                                <div className="row my-2">
                                    <div className="col">
                                        <b>Link Type:&emsp;</b>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name={"urlTypeRadio" + linkIndex} id={"videoLink" + linkIndex} value={CPLinkType.Video} checked={link.type == CPLinkType.Video} onChange={e => changeLinkType(linkIndex, e.currentTarget)} />
                                            <label className="form-check-label" htmlFor={"videoLink" + linkIndex}>Video</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name={"urlTypeRadio" + linkIndex} id={"audioLink" + linkIndex} value={CPLinkType.Audio} checked={link.type == CPLinkType.Audio} onChange={e => changeLinkType(linkIndex, e.currentTarget)} />
                                            <label className="form-check-label" htmlFor={"audioLink" + linkIndex}>Audio</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name={"urlTypeRadio" + linkIndex} id={"webLink" + linkIndex} value={CPLinkType.Web} checked={link.type == CPLinkType.Web} onChange={e => changeLinkType(linkIndex, e.currentTarget)} />
                                            <label className="form-check-label" htmlFor={"webLink" + linkIndex}>Web</label>
                                        </div>
                                    </div>

                                </div>
                                <DeleteConfirmationModalComponent
                                    itemId={"removeLinkModal" + (linkIndex)}
                                    itemContent={"Do you want to remove link number " + (linkIndex + 1) + "?"}
                                    deleteFunction={() => removeLink(linkIndex)}
                                />
                            </li>
                        )
                    })}
                </ol>
            </div>
        </div>
    )
}

export default LinksList;